var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-page"},[_c('admin-sidebar',{attrs:{"toggled":_vm.sidebarMobile},on:{"hide":function($event){return _vm.toggleSidebar(false)}}}),_c('div',{staticClass:"page-wrapper"},[_c('admin-header',{on:{"change":_vm.toggleSidebar}}),_c('div',{staticClass:"page-content"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }